import React from 'react';
import PropTypes from 'prop-types';
import HtmlContent from '../HtmlContent';
import Answer from '../Answer';
import NavButton from '../../elements/NavButton';

export default class Question extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validAnswer: true,
    };

    this.validateAnswer = this.validateAnswer.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  validateAnswer = (event) => {
    const { inputAnswer, nextStepHandler } = this.props;

    let isValidAnswer = false;

    if (inputAnswer.length > 0) {
      inputAnswer.forEach((answer) => {
        isValidAnswer = answer.trim() !== '';
      });
    }

    this.setState({
      validAnswer: isValidAnswer,
    });

    if (isValidAnswer) {
      nextStepHandler(event);
    }
  };

  handleModalClose = () => {
    const { closeHandler } = this.props;

    this.setState({
      validAnswer: true,
    });

    closeHandler();
  };

  render() {
    const {
      content,
      answerType,
      answerValues,
      hint,
      handleAnswerInput,
      nextStep,
      inputAnswer,
    } = this.props;
    const { validAnswer } = this.state;
    const {
      AdventCount: {
        translations: {
          common: {
            next,
            close,
          },
          shortcode: {
            enterAnswer,
            selectAnswer,
          },
        },
      },
    } = window;

    return (
      <div className="adventcount-modal">
        <HtmlContent content={content} />
        <Answer
          answerType={answerType}
          answerValues={answerValues}
          answerHandler={handleAnswerInput}
          inputValue={inputAnswer}
        />
        {!validAnswer && (
          <div className="validation-error">
            {answerType === 'Number' || answerType === 'Text' ? enterAnswer : selectAnswer}
          </div>
        )}
        <div className="hint"><HtmlContent content={hint} /></div>
        <div className="adventcount-button-row">
          <NavButton
            toStep=""
            btnLabel={close}
            direction="close"
            clickHandler={this.handleModalClose}
          />
          <NavButton
            toStep={nextStep}
            btnLabel={next}
            direction="next"
            clickHandler={this.validateAnswer}
          />
        </div>
      </div>
    );
  }
}

Question.propTypes = {
  content: PropTypes.string.isRequired,
  answerType: PropTypes.string.isRequired,
  answerValues: PropTypes.arrayOf(PropTypes.string).isRequired,
  hint: PropTypes.string.isRequired,
  handleAnswerInput: PropTypes.func.isRequired,
  nextStep: PropTypes.string.isRequired,
  nextStepHandler: PropTypes.func.isRequired,
  closeHandler: PropTypes.func.isRequired,
  inputAnswer: PropTypes.arrayOf(PropTypes.string).isRequired,
};
